import { Modal } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import BaseButton from "../Button/BaseButton";
import TranslateText from "../TranslateText";
import "../../../assets/style/modalStyle/delete.scss";
import { IconErrorUpload } from "../../../assets/icon";

const ModalShowLogUpload = ({ width = 580, openModal, handleCancel }) => {
  const dispatch = useDispatch();
  return (
    <>
      <Modal
        maskClosable={false}
        title={
          <span style={{ fontSize: 20 }}>
            <TranslateText text={"Thông báo kết quả Tải lên"} />
          </span>
        }
        centered
        open={openModal}
        className="warrperModalErrorUploadExcel"
        footer={[
          <div className="evenSpace">
            <BaseButton
              width={155}
              content={"Đóng"}
              typeBtn="btnOrange"
              handleClick={handleCancel}
            />
          </div>,
        ]}
        width={width}
        onCancel={handleCancel}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "1.5rem",
          }}
        >
          <IconErrorUpload />
        </div>
        <div style={{ fontSize: 16 }}>
          <strong>
            File tải lên đang chứa dữ liệu không hợp lệ tại các dòng cột sau:
          </strong>
          <ul style={{ marginTop: 8, paddingLeft: 20 }}>
            <li>
              Dòng 3 cột <strong>Mã thẻ</strong> không có dữ liệu.
            </li>
            <li>
              Dòng 2 cột <strong>Mã thẻ</strong> dữ liệu không hợp lệ.
            </li>
          </ul>
        </div>
        <div style={{ fontSize: 16 }}>
          <strong>Hướng dẫn xử lý lỗi:</strong>
          <ul style={{ marginTop: 8, paddingLeft: 20 }}>
            <li>
              Cột <strong>Mã thẻ (Cột C)</strong>: Gồm các chữ số từ 0-9, có độ
              dài 12 chữ số và có định dạng cấu trúc{" "}
              <strong>xxxx-xxxx-xxxx</strong>.
            </li>
          </ul>
        </div>
      </Modal>
    </>
  );
};

export default ModalShowLogUpload;
